var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "8" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-space-between pr-4",
                      attrs: { flat: "" },
                    },
                    [
                      _c("p", { staticClass: "mb-0 pt-1 text-h6 ml-2" }, [
                        _vm._v("Recent Cases"),
                      ]),
                      _c(
                        "v-card",
                        { staticClass: "d-flex", attrs: { flat: "" } },
                        [
                          _c(
                            "v-btn-toggle",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                color: "primary",
                                group: "",
                                dense: "",
                                outlined: "",
                              },
                              model: {
                                value: _vm.recentCaseFilter,
                                callback: function ($$v) {
                                  _vm.recentCaseFilter = $$v
                                },
                                expression: "recentCaseFilter",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                { attrs: { value: "personal", small: "" } },
                                [_vm._v(" My ")]
                              ),
                              _c(
                                "v-btn",
                                { attrs: { value: "all", small: "" } },
                                [_vm._v(" All ")]
                              ),
                            ],
                            1
                          ),
                          _c("DialogForm", {
                            attrs: {
                              title: "Open Case",
                              "submit-text": "Open",
                              "disable-submit": !_vm.caseToOpen.id,
                              submit: _vm.openCase(_vm.caseToOpen),
                              "max-width": 0,
                              "dialog-props": { width: "unset" },
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "mt-1 mx-1",
                                          attrs: {
                                            rounded: "",
                                            small: "",
                                            outlined: "",
                                            color: "primary",
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", { staticClass: "mr-2" }, [
                                          _vm._v(" mdi-folder-open-outline"),
                                        ]),
                                        _vm._v("open case "),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    _c("FolderTreeSelect", {
                                      attrs: {
                                        "show-cases": "",
                                        "select-only": "case",
                                      },
                                      model: {
                                        value: _vm.caseToOpen,
                                        callback: function ($$v) {
                                          _vm.caseToOpen = $$v
                                        },
                                        expression: "caseToOpen",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-1 mx-1",
                              attrs: {
                                rounded: "",
                                small: "",
                                outlined: "",
                                color: "primary",
                                to: { name: "Folders" },
                              },
                            },
                            [_vm._v(" see All cases")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        _vm._l(_vm.cases, function (caseItem) {
                          return _c(
                            "v-col",
                            { key: caseItem.id, attrs: { sm: "4", cols: "6" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "d-flex flex-column",
                                  attrs: { height: "100%", active: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.caseCardClick(caseItem)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-card-title",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "d-flex text-wrap case-title",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(caseItem.name) + " "
                                          ),
                                          _c("v-spacer"),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "mt-0",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                                to: {
                                                                  name: "Folders",
                                                                  params: {
                                                                    folderId:
                                                                      caseItem.directory_id,
                                                                  },
                                                                },
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-folder-open-outline"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Open containing folder"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        { staticClass: "font-weight-light" },
                                        [
                                          _vm._v(
                                            "Last modified: " +
                                              _vm._s(
                                                _vm.formatDate(caseItem.updated)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "text-body-2 grow" },
                                    [
                                      caseItem.notes.length > 80
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                right: "",
                                                "max-width": "240",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "div",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  caseItem.notes.replace(
                                                                    /^(.{80}[^\s]*).*/,
                                                                    "$1"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                            _c("span", [
                                                              _vm._v("..."),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("p", [
                                                _vm._v(_vm._s(caseItem.notes)),
                                              ]),
                                            ]
                                          )
                                        : _c("div", [
                                            _vm._v(_vm._s(caseItem.notes)),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-card-actions",
                                    { staticClass: "justify-space-around" },
                                    _vm._l(
                                      _vm.caseJobs(caseItem),
                                      function (job) {
                                        return _c(
                                          "v-card",
                                          {
                                            key:
                                              "job-" +
                                              job.name +
                                              "-case-" +
                                              caseItem.id,
                                            attrs: {
                                              flat: "",
                                              color: "transparent",
                                            },
                                          },
                                          [
                                            job.status !== "NOT_STARTED"
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function (ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "v-badge",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      job.value,
                                                                    color:
                                                                      job.color,
                                                                    dot: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-card",
                                                                    _vm._g(
                                                                      {
                                                                        attrs: {
                                                                          flat: "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.toOutput(
                                                                                job
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          job.name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "snakeToHuman"
                                                          )(job.status)
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _c(
                                                  "v-card",
                                                  {
                                                    attrs: {
                                                      flat: "",
                                                      color: "transparent",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(job.name))]
                                                ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "d-flex flex-column",
                  attrs: { height: "100%", flat: "" },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-space-between",
                      attrs: { flat: "" },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "mb-0 pt-1 text-h6" },
                        [
                          _c("v-icon", [
                            _vm._v("mdi-clipboard-check-multiple"),
                          ]),
                          _vm._v(" Recent Jobs "),
                        ],
                        1
                      ),
                      _c(
                        "v-card",
                        { staticClass: "d-flex", attrs: { flat: "" } },
                        [
                          _c(
                            "v-btn-toggle",
                            {
                              staticClass: "mr-6",
                              attrs: {
                                color: "primary",
                                group: "",
                                dense: "",
                                outlined: "",
                              },
                              model: {
                                value: _vm.recentJobsFilter,
                                callback: function ($$v) {
                                  _vm.recentJobsFilter = $$v
                                },
                                expression: "recentJobsFilter",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                { attrs: { value: "personal", small: "" } },
                                [_vm._v(" My ")]
                              ),
                              _c(
                                "v-btn",
                                { attrs: { value: "all", small: "" } },
                                [_vm._v(" All ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "Jobs" } } },
                            [
                              _c(
                                "p",
                                { staticClass: "mb-0 pt-3 text-caption" },
                                [_vm._v("See all jobs")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "mb-4" }),
                  _vm._l(_vm.jobsCards, function (job) {
                    return _c(
                      "v-card",
                      { key: "job-" + job.id, attrs: { flat: "" } },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-list-item",
                                        _vm._g(
                                          {
                                            attrs: { dense: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.jobItemClick(job)
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                [
                                                  _c("FeathersVuexGet", {
                                                    attrs: {
                                                      service: "cases",
                                                      id: job.case_id,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var caseItem =
                                                              ref.item
                                                            return [
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      caseItem
                                                                        ? caseItem.name
                                                                        : ""
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption height-1rem",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(ID: " +
                                                                        _vm._s(
                                                                          job.case_id
                                                                        ) +
                                                                        ")"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("v-list-item-subtitle", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("snakeToHuman")(
                                                      job.type_name
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-list-item-icon",
                                                          _vm._g({}, on),
                                                          [
                                                            job.status !==
                                                            "IN_PROGRESS"
                                                              ? _c("v-icon", {
                                                                  attrs: {
                                                                    color:
                                                                      job.iconColor,
                                                                  },
                                                                  domProps: {
                                                                    textContent:
                                                                      _vm._s(
                                                                        job.iconText
                                                                      ),
                                                                  },
                                                                })
                                                              : _c(
                                                                  "v-progress-circular",
                                                                  {
                                                                    attrs: {
                                                                      indeterminate:
                                                                        "",
                                                                      color:
                                                                        "secondary",
                                                                      size: "24",
                                                                    },
                                                                  }
                                                                ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("snakeToHuman")(
                                                      job.status
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  job.status === "COMPLETE"
                                    ? "See outputs"
                                    : "See job"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "p",
                    { staticClass: "mt-4 mb-0 text-h6" },
                    [
                      _c("v-icon", [_vm._v("mdi-message-text")]),
                      _vm._v(" Messages"),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "mb-4" }),
                  _vm._l(_vm.messages, function (message) {
                    return _c(
                      "v-card",
                      { key: "message-" + message.id, attrs: { flat: "" } },
                      [
                        _c(
                          "v-list-item",
                          {
                            attrs: { dense: "" },
                            on: {
                              click: function ($event) {
                                return _vm.jobItemClick(_vm.job)
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(" " + _vm._s(message.message) + " "),
                                ]),
                                _c(
                                  "v-list-item-subtitle",
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.formatDate(message.created))
                                      ),
                                    ]),
                                    _vm._v(" | "),
                                    _c("FeathersVuexGet", {
                                      attrs: {
                                        service: "jobs",
                                        id: message.job_id,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var job = ref.item
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("snakeToHuman")(
                                                        job ? job.type_name : ""
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-subtitle",
                                  [
                                    _c("FeathersVuexGet", {
                                      attrs: {
                                        service: "cases",
                                        id: message.case_id,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var caseItem = ref.item
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        caseItem
                                                          ? caseItem.name
                                                          : ""
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-caption height-1rem",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(ID: " +
                                                          _vm._s(
                                                            message.case_id
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "p",
                    { staticClass: "mt-4 mb-0 text-h6" },
                    [
                      _c("v-icon", [_vm._v("mdi-book-open-page-variant")]),
                      _vm._v(" Tutorials"),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "mb-4" }),
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    _vm._l(_vm.calculations, function (calculation) {
                      return _c(
                        "v-list-item",
                        {
                          key: calculation.title,
                          attrs: { to: calculation.to },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(calculation.title)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex flex-column mt-4",
                      attrs: { outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "text-subtitle-1" },
                        [
                          _vm._v(
                            " Release: " +
                              _vm._s(_vm.currentRelease.version || "") +
                              " "
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-chip",
                                        _vm._g(
                                          {
                                            staticClass: "mx-2",
                                            attrs: {
                                              color: "primary",
                                              outlined: "",
                                              "x-small": "",
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.timeFrom(
                                                  _vm.currentRelease.date
                                                )
                                              ) +
                                              " ago "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.currentRelease.date,
                                      "DATE_SHORT"
                                    ) || ""
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("v-card-subtitle", { staticClass: "text-caption" }),
                      _c("v-card-text", [
                        _c("div", {
                          staticClass: "markdown-index",
                          domProps: {
                            innerHTML: _vm._s(_vm.currentRelease.html),
                          },
                        }),
                      ]),
                      _c(
                        "v-card-actions",
                        { staticClass: "pl-6 text-caption" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "Releases" } } },
                            [_vm._v(" See older versions ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }